var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "table",
      {
        staticClass: "table tablerow",
        attrs: { "aria-labelledby": _vm.labelledBy ? _vm.labelledBy : null }
      },
      [
        _c("thead", [
          _c("tr", [
            _c(
              "th",
              { staticClass: "w-10", attrs: { id: _vm.labelledBy + "_0" } },
              [_c("span", [_vm._v(_vm._s(_vm.$t(_vm.columnTitles[0])))])]
            ),
            _vm._v(" "),
            _c(
              "th",
              { staticClass: "w-30", attrs: { id: _vm.labelledBy + "_1" } },
              [_c("span", [_vm._v(_vm._s(_vm.$t(_vm.columnTitles[1])))])]
            ),
            _vm._v(" "),
            _c(
              "th",
              {
                staticClass: "w-15 right",
                attrs: { id: _vm.labelledBy + "_2" }
              },
              [_c("span", [_vm._v(_vm._s(_vm.$t(_vm.columnTitles[2])))])]
            ),
            _vm._v(" "),
            _c(
              "th",
              {
                staticClass: "w-15 right",
                attrs: { id: _vm.labelledBy + "_3" }
              },
              [_c("span", [_vm._v(_vm._s(_vm.$t(_vm.columnTitles[3])))])]
            ),
            _vm._v(" "),
            _c(
              "th",
              {
                staticClass: "w-15 right",
                attrs: { id: _vm.labelledBy + "_4" }
              },
              [_c("span", [_vm._v(_vm._s(_vm.$t(_vm.columnTitles[4])))])]
            ),
            _vm._v(" "),
            _c(
              "th",
              {
                staticClass: "w-15 right",
                attrs: { id: _vm.labelledBy + "_5" }
              },
              [_c("span", [_vm._v(_vm._s(_vm.$t(_vm.columnTitles[5])))])]
            )
          ])
        ]),
        _vm._v(" "),
        _c(
          "tbody",
          _vm._l(_vm.premise.yearlyData, function(row, index) {
            return _c(
              "tr",
              {
                key: row.year,
                staticClass: "aidapplications-main-row border-0"
              },
              [
                _c("th", { staticClass: "w-10 row-heading" }, [
                  _c("span", [
                    _vm._v(
                      _vm._s(
                        _vm.rowHeaderKey
                          ? _vm.$t(_vm.rowHeaderKey, [row.year])
                          : row.year
                      )
                    )
                  ])
                ]),
                _vm._v(" "),
                _vm.options
                  ? _c("single-select-table-cell", {
                      attrs: {
                        classes: ["input-cell"],
                        options: _vm.options,
                        required: _vm.getRequired(index, row),
                        dropdownId: "premiseowners_" + index,
                        title: _vm.columnTitles[1],
                        srLabel: true
                      },
                      model: {
                        value: row.owner,
                        callback: function($$v) {
                          _vm.$set(row, "owner", $$v)
                        },
                        expression: "row.owner"
                      }
                    })
                  : !_vm.ownPremises
                  ? _c(
                      "td",
                      { staticClass: "w-30 input-cell" },
                      [
                        _c("text-area-control", {
                          attrs: {
                            rows: 1,
                            maxLength: 30,
                            required: _vm.getNameRequired(index, row),
                            placeholderKey: "Placeholder.TextArea",
                            "aria-required": _vm.getNameRequired(index, row),
                            labelledBy: _vm.labelledBy + "_1"
                          },
                          model: {
                            value: row.name,
                            callback: function($$v) {
                              _vm.$set(row, "name", $$v)
                            },
                            expression: "row.name"
                          }
                        })
                      ],
                      1
                    )
                  : _c("td", { staticClass: "w-30 disabled-background" }),
                _vm._v(" "),
                _c(
                  "td",
                  { staticClass: "w-15 right input-cell" },
                  [
                    _c("numeric-input-control", {
                      attrs: {
                        disabled: _vm.isReadOnly,
                        required: _vm.getRequired(index, row),
                        placeholderKey: "EnterValue",
                        labelledBy: _vm.labelledBy + "_2"
                      },
                      model: {
                        value: row.costs,
                        callback: function($$v) {
                          _vm.$set(row, "costs", $$v)
                        },
                        expression: "row.costs"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "td",
                  { staticClass: "w-15 right input-cell" },
                  [
                    _c("numeric-input-control", {
                      attrs: {
                        disabled: _vm.isReadOnly,
                        required: _vm.getRequired(index, row),
                        placeholderKey: "EnterValue",
                        labelledBy: _vm.labelledBy + "_3"
                      },
                      model: {
                        value: row.otherCosts,
                        callback: function($$v) {
                          _vm.$set(row, "otherCosts", $$v)
                        },
                        expression: "row.otherCosts"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "td",
                  { staticClass: "w-15 right input-cell" },
                  [
                    _c("numeric-input-control", {
                      attrs: {
                        disabled: _vm.isReadOnly,
                        required: _vm.getRequired(index, row),
                        placeholderKey: "EnterValue",
                        labelledBy: _vm.labelledBy + "_4"
                      },
                      model: {
                        value: row.area,
                        callback: function($$v) {
                          _vm.$set(row, "area", $$v)
                        },
                        expression: "row.area"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "td",
                  { staticClass: "w-15 right input-cell" },
                  [
                    _c("text-area-control", {
                      attrs: {
                        alignRight: true,
                        rows: 1,
                        maxLength: 5,
                        required: _vm.getRequired(index, row),
                        rules: _vm.postalCodeRules,
                        placeholderKey: "Placeholder.TextArea",
                        labelledBy: _vm.labelledBy + "_5",
                        showMaxLengthInPlaceholder: false
                      },
                      model: {
                        value: row.postalCode,
                        callback: function($$v) {
                          _vm.$set(row, "postalCode", $$v)
                        },
                        expression: "row.postalCode"
                      }
                    })
                  ],
                  1
                )
              ],
              1
            )
          }),
          0
        )
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }